import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";

declare var ko: any;

export class featurePointsHolidaysEdit_template extends vnTemplate {
    public validationsList: validationsList_template;

    protected getTemplateHtml(): string {
        return `<div class="form-header">
                <h3 class="form-title icon i-calendar-b">Edit Holidays</h3>

                <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close" type="button"></button>
            </div>
            <div  class="w-list-results" id="list-results"  data-bind="" style="position: relative">
                <div class="form-body full-width">
                    <!-- ko foreach: holidayPeriods -->
                        <div class="form-group" style="display:flex; justify-content:space-between;">
                            <div>
                                <label class="form-label" data-bind="attr: { id: 'holidayStartDate_' + $index() }">Start Date</label>
                                <input class="input-text" type="date" name="assigneeStartDate" data-bind="value: startDate, attr: { id: 'holidayStartDate_' + $index(), min: $parent.quarterStartDate(), max: $parent.quarterEndDate()  }">
                            </div>
                            <div>
                                <label class="form-label" data-bind="attr: { id: 'holidayEndDate_' + $index() }">End Date</label>
                                <input class="input-text" type="date" name="assigneeStartDate" data-bind="value: endDate, attr: { id: 'holidayEndDate_' + $index(), min: $parent.quarterStartDate(), max: $parent.quarterEndDate() }">
                            </div>
                            <div style="margin-top: auto;">
                                <button data-bind="event: { click: $parent.onClickRemoveHoliday.bind($data, $index(), $data)}" class="btn" type="button">Delete</button>
                            </div>
                        </div>
                    <!-- /ko -->
                    <div class="form-group" style="margin-top: 1em;">
                        <button data-bind="click: onClickAddHoliday" class="btn" type="button">Add</button>
                    </div>
                </div>
            </div>
            <div class="form-footer">
                <button class="btn" type="button" data-bind="click: onClickCancel ">Cancel</button>
                <button class="btn highlight" type="button" data-bind="click: onClickSave ">Save</button>
            </div>`;
    }

    protected buildViewModel(): any {
        let huit_neuf_this = this;
        let viewModel = {
            year: ko.observable()
            ,quarter: ko.observable()
            ,quarterStartDate: ko.observable(null)
            ,quarterEndDate: ko.observable(null)
            ,holidayPeriods: ko.observableArray([])
            ,onClickAddHoliday: function(){ huit_neuf_this.onClickAddHoliday(); }
            ,onClickRemoveHoliday: function(index, data){ huit_neuf_this.onClickRemoveHoliday(index); }
            ,onClickCancel: function(){ huit_neuf_this.onClickCancel(); }
            ,onClickSave: function(){ huit_neuf_this.onClickSave(); }
            ,isResultsLoading: ko.observable(0)
        }

        return viewModel;
    }

    protected initPartial(): void {
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);
    }

    public getViewModelForRequest() {

        return {
            year: this.getTemplateViewModel().year,
            quarter: this.getTemplateViewModel().quarter,
            holidayPeriods: this.getTemplateViewModel().holidayPeriods
        }
    }

    public setHolidaysPeriods(holidaysPeriods): void {
        this.getTemplateViewModel().holidayPeriods(holidaysPeriods);
    }

    public setHolidaysCalendarMinMaxDates(quarterDates): void {
        this.getTemplateViewModel().quarterStartDate(quarterDates.quarterStartDate);
        this.getTemplateViewModel().quarterEndDate(quarterDates.quarterEndDate);
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-form", "margin-top"];
    }

    protected getTemplateName(): string {
        return "featurePointsHolidaysEdit_template";
    }

    public setYear(year) {
        this.getTemplateViewModel().year(year);
    }

    public setQuarter(quarter): void {
        this.getTemplateViewModel().quarter(quarter);
    }

    private onClickAddHoliday(){
        this.getTemplateViewModel().holidayPeriods.push({startDate:null,endDate:null});
    }

    private onClickRemoveHoliday(index){
        this.getTemplateViewModel().holidayPeriods.splice(index,1);
    }

    private onClickCancel(){
        this.caller.cancelHolidayEdit();
    }

    private onClickSave(){
        this.caller.saveHolidayEdit();
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/featurePointsHolidaysEdit_template.ts